import React, { useEffect,useState } from "react";
import { showSuccess, showError } from "component/utils/SweetAlert";
import axios from "axios";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import Datatables from "component/booking/Datatables";
import DetailBooking from "component/booking/DetailBooking";

function Canceled() {
  const [activeContent, setActiveContent] = useState("booking");
  const [selectedCanceled, setSelectedCanceled] = useState(null);
  const [canceled, setCanceled] = useState([]);

  const fetchCanceled = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${process.env.REACT_APP_API}/show-booking`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ status: "CANCELED_REJECTED" })
      });
  
      if (!response.ok) throw new Error("Gagal mengambil data booking canceled");
  
      const data = await response.json();
      setCanceled(Array.isArray(data.data) ? data.data : []);
    } catch (error) {
      console.error("Error fetching canceled:", error);
    }
  };

  useEffect(() => {
      document.title = "Green Hill Kemuning | Booking Canceled";
      window.scrollTo(0, 0);
      fetchCanceled();
  }, []);


  const handleDetailBooking = (DetailBooking) => {
    setActiveContent("DetailBooking");
    setSelectedCanceled(DetailBooking);
  }

    const handleCanceledBooking = async (invoice, action) => {
      try {
        if (!invoice) {
          alert("Invoice tidak ditemukan");
          return;
        }

        const payload = {
          invoice: invoice,
          status: action === "accept" ? "Canceled" : "Rejected"
        };

        const response = await axios.put(
          `${process.env.REACT_APP_API}/booking-canceled`,
          payload
        );

        if (response.status === 200 || response.status === 201) {
          showSuccess(response.data.message || "Confirm booking berhasil");
          handleBack();
        } else {
          showError(response.data.message || "Gagal Confirm Booking");
        }
      } catch (error) {
        console.error("Error confirm booking:", error);
        showError(error.response?.data?.message || "Terjadi kesalahan saat confirm booking");
      }
    };

    const handleBack = () => {
        fetchCanceled();
        setActiveContent("booking");
    };
      
  return (
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                  <div class="row px-4">
                      <div class="card shadow p-3">
                        <div class="card-body">

                          {activeContent === "booking" && (
                            <div className="row content-item">
                              <div className="d-flex justify-content-between align-items-center">
                                <h5 className="card-title mb-3">Canceled Booking</h5>
                              </div>
                              <Datatables
                                data={canceled}
                                onDetailBooking={handleDetailBooking}
                                responsive
                                dense
                                showStatus={true}
                              />
                            </div>
                          )}

                          {activeContent === "DetailBooking" && (
                            <div className="row content-item">
                              <DetailBooking
                                booking={selectedCanceled}
                                onBack={handleBack}
                                onStatusBooking={handleCanceledBooking}
                              />
                            </div>
                          )}

                        </div>  
                      </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-menu-toggle"></div>
 
    </div>
  );
}

export default Canceled;
